var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRangeErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15 1.75H3.85V2.45H3.15V1.75ZM3.5 5.25C3.6925 5.25 3.85 5.0925 3.85 4.9V3.5C3.85 3.3075 3.6925 3.15 3.5 3.15C3.3075 3.15 3.15 3.3075 3.15 3.5V4.9C3.15 5.0925 3.3075 5.25 3.5 5.25ZM3.5 0C1.568 0 0 1.568 0 3.5C0 5.432 1.568 7 3.5 7C5.432 7 7 5.432 7 3.5C7 1.568 5.432 0 3.5 0ZM3.5 6.3C1.9565 6.3 0.7 5.0435 0.7 3.5C0.7 1.9565 1.9565 0.7 3.5 0.7C5.0435 0.7 6.3 1.9565 6.3 3.5C6.3 5.0435 5.0435 6.3 3.5 6.3Z",
    fill: "#F04545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRangeErrorIcon);
export default __webpack_public_path__ + "static/media/range_error_icon.f471be20546fd36b83fb9e60bcb29306.svg";
export { ForwardRef as ReactComponent };